import React from 'react'
import Header from '../Component/Header'
// import CoureseBreadcrumb from '../Component/CoureseBreadcrumb'
import CoureseSubBreadcrumb from '../Component/CoureseSubBreadcrumb'
import Footer from '../Component/Footer'
import Testimonials from '../Component/Testimonials'
import Blog from '../Component/Blog'
import OurCourse from '../Component/OurCourse'
import FAQ from '../Component/FAQ'
function SubCoursePage() {
    return (
        <div>
            <Header />
            {/* <CoureseBreadcrumb /> */}
            <CoureseSubBreadcrumb />
            <OurCourse />
            <FAQ />
            <Testimonials />
            <Blog />
            <Footer />
        </div>
    )
}

export default SubCoursePage